/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ReportingControllerGetSkillUsageQueryResponse, ReportingControllerGetSkillUsageQueryParams, ReportingControllerGetSkillUsage400, ReportingControllerGetSkillUsage401, ReportingControllerGetSkillUsage403, ReportingControllerGetSkillUsage404 } from "../../models/reportingController/ReportingControllerGetSkillUsage";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { reportingControllerGetSkillUsage } from "../../clients/reportingService/reportingControllerGetSkillUsage";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const reportingControllerGetSkillUsageQueryKey = (params: ReportingControllerGetSkillUsageQueryParams) => [{
  url: '/api/v1/reporting/skills'
}, ...(params ? [params] : [])] as const;
export type ReportingControllerGetSkillUsageQueryKey = ReturnType<typeof reportingControllerGetSkillUsageQueryKey>;
export function reportingControllerGetSkillUsageQueryOptions(params: ReportingControllerGetSkillUsageQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = reportingControllerGetSkillUsageQueryKey(params);
  return queryOptions<ReportingControllerGetSkillUsageQueryResponse, ResponseErrorConfig<ReportingControllerGetSkillUsage400 | ReportingControllerGetSkillUsage401 | ReportingControllerGetSkillUsage403 | ReportingControllerGetSkillUsage404>, ReportingControllerGetSkillUsageQueryResponse, typeof queryKey>({
    enabled: !!params,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return reportingControllerGetSkillUsage(params, config);
    }
  });
}

/**
 * @summary Get skills usage for an organization: organization and personal skills created and applied, most-used organization skills, applications per skill, a bucketed series and the previous-period comparison. Honors the date filters.
 * {@link /api/v1/reporting/skills}
 */
export function useReportingControllerGetSkillUsage<TData = ReportingControllerGetSkillUsageQueryResponse, TQueryData = ReportingControllerGetSkillUsageQueryResponse, TQueryKey extends QueryKey = ReportingControllerGetSkillUsageQueryKey>(params: ReportingControllerGetSkillUsageQueryParams, options: {
  query?: Partial<QueryObserverOptions<ReportingControllerGetSkillUsageQueryResponse, ResponseErrorConfig<ReportingControllerGetSkillUsage400 | ReportingControllerGetSkillUsage401 | ReportingControllerGetSkillUsage403 | ReportingControllerGetSkillUsage404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? reportingControllerGetSkillUsageQueryKey(params);
  const query = useQuery({
    ...reportingControllerGetSkillUsageQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ReportingControllerGetSkillUsage400 | ReportingControllerGetSkillUsage401 | ReportingControllerGetSkillUsage403 | ReportingControllerGetSkillUsage404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}